/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_OfficialInputs */

const en_gc_home_official = /** @type {(inputs: Gc_Home_OfficialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft official site`)
};

const zh_gc_home_official = /** @type {(inputs: Gc_Home_OfficialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft 官方网站`)
};

/**
* | output |
* | --- |
* | "ArtCraft official site" |
*
* @param {Gc_Home_OfficialInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_official = /** @type {((inputs?: Gc_Home_OfficialInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_OfficialInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_official(inputs)
	return zh_gc_home_official(inputs)
});
export { gc_home_official as "gc.home.official" }